/* eslint-disable no-prototype-builtins */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { loanApplicationStatus } from "assets/properties/properties";
import { textFormat } from "utils/Utils";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import brandTheme from "brandTheme/Theme";
import { useNavigate } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";

const style = () => ({
  selectContainer: {
    display: "block",
    "& .MuiFormControl-root": {
      "& .MuiInput-underline:before": {
        content: "inherit",
      },
      "& .MuiInput-underline.Mui-focused:after": {
        transform: "inherit",
        borderBottom: "inherit",
      },
      "& .MuiSelect-select.MuiSelect-select": {
        padding: "6px 10px",
        borderRadius: "5px",
        border: "1px solid gray",
        textAlign: "left",
      },
    },
  },
  buttonContainer: {
    textAlign: "right",
    "@media (max-width:600px)": {
      textAlign: "center",
    },
  },
  nextButton: {
    padding: "0px 40px",
    letterSpacing: "1px",
  },
  nextButton1: {
    padding: "0px 40px",
  },
  errorTextArea:{
    borderColor:brandTheme.errorColor,
  }
});

const DiscrepancyDecisionApproval = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  status,
  classes,
  featureFlags,
}) => {
  const navigate = useNavigate();
  const [decisionList] = useState(["NO_DISCREPENCY", "DISCREPANCY"]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [decision, setDecision] = useState("");
  const [decisionState, setDecisionState] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksState, setRemarksState] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = featureFlags;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const isValidated = () => {
    if (decision === "") {
      setDecisionState(true);
    } else {
      setDecisionState(false);
    }
    if (remarks === "") {
      setRemarksState(true);
    } else {
      setRemarksState(false);
    }

    if (decision && decision !== "" && remarks !== "") {
      return true;
    } else {
      return false;
    }
  };

const handlecreateuserSubmit = async (event) => {
  if (decision === "" || typeof decision === "undefined") {
    setDecisionState(true);
  }
  if (status === "DISCREPANCY") {
    if (isValidated()) {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.DISCREPANCY_DECEISION_GET_ID + loanApplicationId,
        authToken: authToken,
      });
      if (result?.data.id) {
        const res = await apiHandler({
          url: endpoint.DISCREPANCY_DESCISION_STATUS,
          method: "POST",
          authToken: authToken,
          data: {
            id: result?.data?.id,
            status: decision,
            remarks: remarks,
          },
        });
        setCallInProgress(false);
        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          return;
        } else {
           navigate("/loanservice/discrepancyApproval", { state: { from: '' } });
        }
      }else{
          toastUpdate("Error", result?.data?.user_description || 'Discrepancy decision not found', true);
      }
    }
  }
};



  const handlecanceluser = () => {
    setBack();
  };

  const handlenext = () => {
    setNext();
  };

  const back = () => {
    setBack();
  };
  const handleCloseModal = () => {
     navigate("/loanservice/discrepancyApproval", { state: { from: '' } });
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="Decision Details" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Decision*"
              error={decisionState}
              value={decision || ""}
              setState={setDecision}
              data={decisionList}
              disabled={!editable}
              setError={setDecisionState}
              id="decision"
              type="decision"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <textarea
              placeholder="Remarks"
              onChange={(e) => {
                if (editable) {
                  setRemarks(e.target.value);
                  setRemarksState(false);
                }
              }}
              value={textFormat(remarks)}
              disabled={!editable}
              required
              id="remarks"
              style={{ width: "100%", borderRadius: "5px" }}
              className={remarksState ? classes.errorTextArea : ""}
            />
          </Grid>
          {status === "DISCREPANCY" ? (
             <GridContainer style={{ flexDirection: "row" }}>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.buttonContainer}
                style={{
                  textAlign: window.innerWidth <= 600 ? "center" : "right",
                }}
              >
                <Button
                  size="small"
                  onClick={() => handlecanceluser()}
                  className={classes.nextButton1}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress}
                  onClick={(event) => {
                    handlecreateuserSubmit(event);
                  }}
                >
                 Submit
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={12}
                            className={classes.buttonContainer}
                            style={{
                              textAlign: window.innerWidth <= 600 ? "center" : "right",
                            }}
                          >
                            <Button
                              style={{ margin: "5px" }}
                              size="small"
                              className={classes.nextButton1}
                              onClick={() => back()}
                            >
                              Back
                            </Button>
                            <Button
                              style={{ margin: "5px" }}
                              size="small"
                              className={classes.nextButton}
                              onClick={() =>
                                status === "REJECTED" ? handleCloseModal() : handlenext()
                              }
                            >
                              {status === "REJECTED" ? "Close" : "Next"}
                            </Button>
                          </GridItem>
                        </GridContainer>
          )}
          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

DiscrepancyDecisionApproval.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  status: PropTypes.object,
};

export default withStyles(style)(DiscrepancyDecisionApproval);
